export default __webpack_public_path__ + "static/media/history.97db60a4.jpg";